import { CommonEtat, SensOperation } from '@core-lib/enums';
import { Frais } from '@core-lib/enums/coordonnes-bancaires.enum';
import { CommentaireMotif, TypeAPR } from 'projects/app-back/src/app/shared-module/enums';
import { IHasETag, INatureOperation, IQualiteTiers, ITypeOperation } from '.';
import { IDegreRisque, INatureAffaire } from './affaire.model';
import { IModeReception } from './mode-reception.model';
import { RegistreType } from '@core-lib/enums/pays.enum';

export interface IReferentiel {
	id: string;
	code: string;
	libelle: string;
}

export interface IReferentials {
	pays?: IPays[];
	devises?: IDevise[];
	allDevises?: IDevise[];
	departements?: IDepartement[];
	degresRisque?: IDegreRisque[];
	typesFacteurRisque?: ITypeFacteurRisque[];
	etatsTraitementNames?: CommonEtat[];
	groupesCodeEconomique?: IListeCodeEconomique[];
	naturesCompte?: IReferentiel[];
	naturesAffaire?: INatureAffaire[];
	qualiteTiers?: IQualiteTiers[];
	modelesData?: IModeleData[];
	typesOperation?: ITypeOperation[];
	naturesOperation?: INatureOperation[];
	modesReception?: IModeReception[];
	sousMotifs?: ISousMotif[];
	listesReglementairePays?: IListesReglementaires[];

}

export interface IListesReglementaires {
	id: number;
	code: string;
	libelle: string;
}
export interface IPays {
	id: string;
	nom: string;
	codeISO: string;
	estNationalite: boolean;
	codeEconomiqueId?: string;
	zoneSEPA?: boolean;
	longueurIBAN?: number;
	swiftBIC?: boolean;
	codeABA?: boolean;
	registre?: RegistreType;
	adresseBeneficiaireObligatoire?: boolean;
	codeEconomiqueModifiable?: boolean;
	paysParent: IPays;
	codeListeCodeEconomique?: string;
}

export interface IDevise {
	id: string;
	libelle: string;
	codeISO: string;
	symbole: string;
	nombreDecimales?: number;
	estActif?: boolean;
}

export interface IDepartement {
	id: string;
	code: string;
	nom: string;
	estTerritoire: boolean;
}

export interface IListeCodeEconomique {
	codeListeCodeEconomique: string;
	libelleGroupe: string;
	liste: ICodeEconomique[];
}

export interface ICodeEconomique {
	id: string;
	libelle: string;
	code: string;
	codeEconomiqueGroupe: string;
}

export interface ICoordonneeBancaire extends IHasETag {
	id?: string;
	deviseReferenceId?: string;
	paysBanqueBeneficaireId: string;
	ibanBeneficiaire?: string;
	codeEconomiqueId?: string;
	libelleComplementaire?: string;
	numeroCompte?: string;
	documents?: any[];
	deviseCompteCrediteId?: string;
	adresseBeneficiaire?: string;
	paysBeneficaireId?: string;
	utilisateurCreationId?: string;
	nomBanque?: string;
	adresseBanque?: string;
	swiftBic?: string;
	abaRoutingNumber?: string;
	retraitId?: string;
	frais?: Frais;
	saisieVirementManuscrit?: boolean;
	virementUrgent?: boolean;
	virementTarget?: boolean;
	estCertifie?: boolean;
}

export interface IParames {
	listeParametres: IParameters[];
}

export interface IParameters {
	id: string;
	code: string;
	valeur: string;
	carpaId: string;
}

export interface IAlfrescoDocumentUploadRequest {
	filesList: IDocumentWithDetails[];
}

export interface IDocumentWithDetails {
	file?: any;
	commentaire?: string;
	typePieceJointeId?: string;
	libelle?: string;
}

export interface IReferentielNatureOperation {
	id: string;
	nom: string;
	code: string;
	sens: SensOperation;
	delaiGarantieBonneFin: number;
	montantMinDoubleSaisie?: number;
}

export interface IReferentielTypeOperation {
	id: string;
	libelle: string;
	code: string;
	sens: SensOperation;
	actif: number;
}

export interface IUtilisateurParametre {
	utilisateurId: string;
	valeur: string;
	code: string;
	id: string;
}

export interface ITypeFacteurRisque {
	id: string;
	libelle?: string;
	code: string;
	type: TypeAPR;
	priority?: number;
}

export interface IModeleData {
	id: string;
	code: string;
	payload?: string;
	champs?: IChampModeleData[];
}

export interface IChampModeleData {
	champ: string;
	description?: string;
}

export interface IJoursFermeture {
	joursFermeture: string[];
}

export interface ISousMotif {
	id: string;
	code: string;
	motif: CommentaireMotif;
	libelle: string;
}

export interface IServiceOrigines {
	id: string;
	libelle: string;
}

export interface IGetAllNaturesOperationQuery {
	sortBy?: ISortDescriptor;
}

// TODO: add to separate file
export interface ISortDescriptor {
	propertyName: string;
	direction: ListSortDirection;
}

export enum ListSortDirection {
	Ascending,
	Descending
}

export interface IPreferenceEmailTelephone {
	emailPreference?: string;
	telephonePreference?: string;
}

export interface ICurrencyMaskOptions {
	align?: 'left' | 'right';
	allowNegative?: boolean;
	allowZero?: boolean;
	decimal?: string;
	precision?: number;
	prefix?: string;
	suffix?: string;
	thousands?: string;
	nullable?: boolean;
	inputMode?: 'Natural' | 'Financial';
}
